import React, { Component, useState } from 'react'
import Dropzone from 'react-dropzone'
import { UploadFile } from "../../api/support"
import PulseLoader from "react-spinners/PulseLoader";
import { Alert } from 'react-bootstrap'

export default class MyDropzone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Loading: false,
            rejectionMessage: null,
            acceptedMessage: null
        }
        this.onAcceptedFiles = this.onAcceptedFiles.bind(this);
        this.onDropRejected = this.onDropRejected.bind(this);
        this.clearAlerts = this.clearAlerts.bind(this);
        this.validator = this.validator.bind(this);
    }

    acceptedMimeTypes = [
        'application/x-compressed',
        'application/zip',
        'application/zip-compressed',
        'application/x-zip-compressed',
        'multipart/x-zip',
        'image/x-windows-bmp',
        'image/bmp',
        'image/x-dwg',
        'image/vnd.dwg',
        'image/gif',
        'image/jpeg',
        'image/pjpeg',
        'image/tiff',
        'image/x-tiff',
        'image/png',
        'image/webp',
        'application/pdf'
    ];

    validator = (file) =>{
        var format = /[^\x00-\x7F]+/;
        if(format.test(file.name)){
            return {message: "Filename includes characters that can not be accepted.  Please rename the file."};
        }else return null;
    
    
    }

    onAcceptedFiles = async (files) => {
        this.setState({
            rejectionMessage: null,
            acceptedMessage: null
        })
        files.forEach(async (file) => {
            //let uploadFile = new File([file], `${this.state.UserID}&#47;${file.name}`)
            try {
                this.props.onUploading();
                this.setState({ Uploading: true });
                let upload = await UploadFile(file);
                this.props.onUpload(upload);
                this.setState({
                    acceptedMessage: upload.msg
                })
            } catch (ex) {
            }
            finally {
                this.setState({ Uploading: false });
            }



        })

    }

    onDropRejected = async (event) => {
        //this.props.onUploadFailed(event[0]);
        this.setState({
            rejectionMessage: event[0].errors[0].message || "File can not be accepted"
        })
    }

    clearAlerts= ()=> {
        this.setState({
            rejectionMessage: null,
            acceptedMessage: null
        })

    }

    render() {
        return (
            <>
                {this.state.rejectionMessage &&
                    <Alert dismissible onClose={() => { this.setState({ rejectionMessage: null }) }} variant={'danger'}>
                        {this.state.rejectionMessage}
                    </Alert>
                }
                {this.state.acceptedMessage &&
                    <Alert dismissible onClose={() => { this.setState({ acceptedMessage: null }) }} variant={'success'}>
                        {this.state.acceptedMessage}
                    </Alert>
                }
                <Dropzone onDrop={this.onAcceptedFiles} onDropRejected={this.onDropRejected} accept={this.acceptedMimeTypes} maxSize={50000000} validator={this.validator}>
                    {({ getRootProps, getInputProps }) => (
                        <section className={"dropzone"}>
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <p>Drag and drop some files here, or click to select files</p>
                                <p>Only Images, PDF's, and ZIP's are accepted.  Size limit is 50MB.</p>
                            </div>

                            {this.state.Uploading && <PulseLoader
                                size={25}
                                color={"#bbb"}
                                loading={this.state.Uploading}
                            />}
                        </section>
                    )}
                </Dropzone>
            </>
        )
    }
}